import React from "react";
import SignupForm from "./SignupForm";

const Signup = (props) => {
  return <SignupForm history={props.history} />;
};

export default Signup;
